// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"59b643b4","150":"5ab304c1","193":"49fc26fd","413":"f111c554","455":"33cd40f5","471":"8aa3eeb9","496":"afab9ee4","506":"4e2308a8","534":"a5f93e42","811":"b3935c39","878":"6645f2df","885":"67d5eb39","958":"63d6dc27","977":"66830e1f"}[chunkId] + ".chunk.js";
};